import { render, staticRenderFns } from "./archivesDetailsDialog.vue?vue&type=template&id=75e0232b&scoped=true"
import script from "./archivesDetailsDialog.vue?vue&type=script&lang=js"
export * from "./archivesDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./archivesDetailsDialog.vue?vue&type=style&index=0&id=75e0232b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0232b",
  null
  
)

export default component.exports